import b from 'b_';
import cx from 'classnames';
import React from 'react';

import './calendar-plan-theme__additional-content-skeleton.scss';

export const CalendarPlanThemeAdditionalContentSkeleton = () => {
    return (
        <div className={b('library-calendar-plan-showcase', 'lesson-additional-content-skeleton')}>
            <div className={b('skeleton', 'header')}>
                <div className={cx(b('skeleton', 'header-title'), 'skeleton-item')} />
                <div className={cx(b('skeleton', 'header-descr'), 'skeleton-item')} />
            </div>
            <div className={b('skeleton', 'footer-items')}>
                <div className="skeleton-item" />
                <div className="skeleton-item" />
                <div className="skeleton-item" />
                <div className="skeleton-item" />
            </div>
        </div>
    );
};
